import React from 'react'
import MapProducers from './MapProducersInZone'

const MapProducersInZoneContainer = ({
  coordinates,
  bounds,
  producers,
  zoom
}) => {
  return coordinates ? (
    <MapProducers coordinates={coordinates} data={producers} zoom={zoom} />
  ) : bounds ? (
    <MapProducers bounds={bounds} data={producers} zoom={zoom} />
  ) : null
}

export default MapProducersInZoneContainer
